import { useCallback, useEffect, useState } from 'react';
import { Check, Hand } from 'lucide-react';
import { SECTION_COLOR, SECTION_BORDER, hlavicky } from '../komunikace';
import { DRUHY_UKOLU, STAVY_UKOLU, formatTermin, poTerminu } from './ukolyUi';
import PrilohyMrizka from '../prilohy/PrilohyMrizka';

const zFotky = (url, i) => ({ id: `f${i}`, nazev: `Fotka ${i + 1}`, je_obrazek: true, url, nahled_url: url, stahnout_url: url });

/** Karta úkolu / hlášení ve zprávě — stav a rychlá akce (Převzít, Hotovo). */
export default function UkolKarta({ id, obnova = 0, isDark, onZmena }) {
    const [d, setD] = useState(null);
    const [bezi, setBezi] = useState(null);

    const nacti = useCallback(() => {
        fetch(`/api/ukoly/${id}`).then(r => (r.ok ? r.json() : null)).then(x => x && setD(x)).catch(() => {});
    }, [id]);
    useEffect(() => { nacti(); }, [nacti, obnova]);

    const akce = async (co) => {
        setBezi(co);
        try {
            const res = await fetch(`/api/ukoly/${id}/${co}`, { method: 'POST', headers: hlavicky() });
            if (res.ok) { setD(await res.json()); onZmena?.(); window.dispatchEvent(new Event('ukoly-zmena')); } else nacti();
        } finally { setBezi(null); }
    };

    if (!d) return <div className="rounded-xl text-sm" style={{ border: `1px solid ${SECTION_BORDER}`, padding: '12px 14px', color: 'var(--text-muted)', width: 'min(420px, 100%)' }}>Načítám…</div>;

    const { Icon, nazev: druhNazev } = DRUHY_UKOLU[d.druh] || DRUHY_UKOLU.ukol;
    const hotovo = d.stav === 'hotovo' || d.stav === 'zamitnuto';
    const hrana = isDark ? 'rgba(255,255,255,0.14)' : 'var(--border-default)';
    const tlac = (co, text, IconT, kladne) => (
        <button type="button" onClick={(e) => { e.stopPropagation(); akce(co); }} disabled={!!bezi} className="flex items-center justify-center gap-1.5 rounded-xl font-bold"
            style={{ flex: 1, height: 40, fontSize: 13.5, cursor: 'pointer', background: kladne ? SECTION_COLOR : 'transparent', color: kladne ? '#fff' : 'var(--text-primary)', border: kladne ? 'none' : `1px solid ${hrana}` }}>
            {bezi === co ? '…' : <><IconT size={15} /> {text}</>}
        </button>
    );

    return (
        <div className="rounded-xl" onClick={e => e.stopPropagation()}
            style={{ border: `1px solid ${hotovo ? hrana : SECTION_BORDER}`, background: isDark ? 'rgba(255,255,255,0.035)' : 'rgba(0,0,0,0.02)', padding: '12px 14px', width: 'min(420px, 100%)' }}>
            <div className="flex items-center gap-2">
                <span style={{ width: 30, height: 30, borderRadius: 8, background: 'rgba(180,122,234,0.12)', color: SECTION_COLOR, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Icon size={16} /></span>
                <span className="text-xs" style={{ color: 'var(--text-muted)' }}>{druhNazev}{d.nalehave ? ' · ' : ''}{d.nalehave && <b style={{ color: '#F87171' }}>naléhavé</b>}</span>
                <span className="ml-auto text-[11px] font-semibold rounded-full" style={{ padding: '2px 8px', color: d.stav === 'hotovo' ? SECTION_COLOR : 'var(--text-secondary)', border: `1px solid ${hrana}` }}>{STAVY_UKOLU[d.stav]}</span>
            </div>
            <p className="font-semibold" style={{ margin: '8px 0 2px', color: 'var(--text-primary)', fontSize: 14.5, textDecoration: d.stav === 'hotovo' ? 'line-through' : 'none', opacity: hotovo ? 0.75 : 1 }}>{d.nazev}</p>
            <p className="text-xs" style={{ margin: 0, color: 'var(--text-muted)' }}>
                {d.resitel ? `→ ${d.resitel}` : d.skupina ? `→ ${d.skupina}` : ''}
                {d.termin ? <span style={{ color: poTerminu(d) ? '#F87171' : undefined, fontWeight: poTerminu(d) ? 600 : 400 }}> · do {formatTermin(d.termin)}</span> : null}
                {d.vozidlo ? ` · ${d.vozidlo}` : ''}
            </p>
            {(d.fotky?.length > 0 || d.prilohy?.length > 0) && (
                <div style={{ marginTop: 8 }}>
                    <PrilohyMrizka prilohy={[...(d.fotky || []).map(zFotky), ...(d.prilohy || [])]} isDark={isDark} velikostNahledu={54} />
                </div>
            )}
            {d.vysledek && <p className="text-xs" style={{ margin: '8px 0 0', color: 'var(--text-secondary)' }}>{d.vyresil}: {d.vysledek}</p>}
            {(d.akce.includes('prevzit') || d.akce.includes('hotovo')) && (
                <div className="flex gap-2" style={{ marginTop: 10 }}>
                    {d.akce.includes('prevzit') && tlac('prevzit', 'Beru si to', Hand, false)}
                    {d.akce.includes('hotovo') && tlac('hotovo', 'Hotovo', Check, true)}
                </div>
            )}
        </div>
    );
}
